import NotificationsVM from './notifications-vm';

export default {
  init: function(node) {
    let params = { parentNode: node };
    let viewModel = new NotificationsVM(params);
    ko.cleanNode(node);
    ko.applyBindings(viewModel, node);
  }
};

